<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <smart-view-dialogue-base
        :close="
            () => {
                this.$emit('close-dialog');
            }
        "
    >
        <template v-slot:heading>
            All Reports on {{ datasetGroupName }}
        </template>
        <template v-slot:content>
            <v-container v-if="errors[datasetGroupUuid]">
                <v-alert
                    v-if="errors[datasetGroupUuid].type === 'error'"
                    type="error"
                >
                    Error updating list of reports
                </v-alert>
                <v-alert
                    v-if="errors[datasetGroupUuid].type === 'FAILURE'"
                    type="error"
                >
                    Creating Report Failed Please Contact Support
                </v-alert>
                <v-alert
                    v-if="errors[datasetGroupUuid].type === 'forbidden'"
                    type="warning"
                >
                    You do not have access to reports for this dataset
                </v-alert>
                <v-alert
                    v-if="errors[datasetGroupUuid].type === 'SUCCESS'"
                    :color="view_options[view.component].color"
                    style="color: white;"
                >
                    <template v-slot:prepend>
                        <v-icon
                            size="30"
                            color="white"
                        >$vuetify.icons.info</v-icon>
                    </template>
                    <v-row align="center" no-gutters>
                        <v-col class="grow">
                            Report has finished processing
                        </v-col>
                        <v-col class="shrink">
                            <v-btn :href="errors[datasetGroupUuid].url">
                                Download
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-alert>
                <report-alert
                    v-if="errors[datasetGroupUuid].type === 'PENDING'"
                    message="Waiting in Queue"
                    :color="view_options[view.component].color"
                />
                <report-alert
                    v-if="errors[datasetGroupUuid].type === 'STARTED'"
                    message="Getting Annotation Information"
                    :color="view_options[view.component].color"
                />
                <report-alert
                    v-if="errors[datasetGroupUuid].type === 'IMAGE'"
                    message="Generating Images"
                    :current="errors[datasetGroupUuid].image"
                    :total="errors[datasetGroupUuid].total"
                    :color="view_options[view.component].color"
                />
                <report-alert
                    v-if="errors[datasetGroupUuid].type === 'GENERATING'"
                    :color="view_options[view.component].color"
                    message="Generating PDF"
                />
                <report-alert
                    v-if="errors[datasetGroupUuid].type === 'UPLOADING'"
                    :color="view_options[view.component].color"
                    message="Uploading PDF"
                />
            </v-container>

            <v-row style="margin: 0" class="px-10 py-2">
                <v-btn
                    :color="view_options[view.component].color"
                    class="mt-3"
                    style="color: white"
                    @click="generateReport()"
                >
                    Generate {{ view_options[view.component].text }} Report
                </v-btn>
                <v-btn v-if="showCrossReferenceButton" :color="view_options[view.component].color"
                    class="mt-3 ml-3" style="color: white" @click="generateReport('cross_reference')">
                    Generate Cross-Reference Report
                </v-btn>
                <div class="flex-grow-1" />
                <v-text-field
                    v-model="search"
                    append-icon="$vuetify.icons.search"
                    label="Search"
                    single-line
                    hide-details
                />
            </v-row>

            <v-container>
                <v-data-table
                    :headers="headers"
                    :items="reports"
                    :hide-default-footer="reports.length < 5"
                    :items-per-page="5"
                    :search="search"
                    :loading="loading"
                    :sort-by="defaultSortBy"
                    loading-text="Loading reports..."
                    no-data-text="There are no reports for this asset, generate one now"
                >
                    <template v-slot:item.date="{ item }">
                        {{ item.date.split(',')[0] }} <br />
                        {{ item.date.split(',')[1] }}
                    </template>
                    <template v-slot:item.assetDate="{ item }">
                        {{ item.assetDate.split(',')[0] }} <br />
                        {{ item.assetDate.split(',')[1] }}
                    </template>
                    <template v-slot:item.viewType="{ item }">
                        <v-chip
                            :color="view_options[item.viewType].color"
                            text-color="white"
                        >
                            <v-avatar left>
                                <v-icon
                                    small
                                    
                                >{{ view_options[item.viewType].icon }}</v-icon>
                            </v-avatar>
                            {{ view_options[item.viewType].text }}
                        </v-chip>
                    </template>
                    <template v-slot:item.url="{ item }">
                        <template
                            v-if="
                                item.state === 'STARTED' ||
                                    item.state === 'PENDING' ||
                                    item.state === 'GENERATING' ||
                                    item.state === 'UPLOADING'
                            "
                        >
                            <v-progress-circular
                                :color="view_options[item.viewType].color"
                                size="23"
                                class="ml-4 my-4"
                                indeterminate
                            />
                        </template>
                        <template v-if="item.state === 'FAILURE'">
                            <v-btn v-if="['browser_capture', 'cross_reference'].includes(item.effective_mode) && item.capture_status === 'complete'"
                                size="small" @click="retryCapturedReport(item)">Retry PDF</v-btn>
                            <v-icon
                                color="red"
                                size="28"
                                class="ml-4 my-3"
                            >$vuetify.icons.close</v-icon>
                        </template>
                        <template v-if="item.state === 'SUCCESS'">
                            <v-btn :href="item.url" icon>
                                <v-icon
                                    small
                                    
                                >$vuetify.icons.download</v-icon>
                            </v-btn>
                        </template>
                    </template>
                </v-data-table>
            </v-container>
        </template>
    </smart-view-dialogue-base>
</template>

<script>
import axios from 'axios';
import ReportAlert from 'components/Reports/ReportAlert.vue';
import SmartViewDialogueBase from 'components/View/SmartViewDialogueBase.vue';
import { trackReportAndExportEvents } from 'js/eventsTracking';
import viewsInfoMixin from 'js/mixins/viewsInfoMixin';
import { mapActions, mapState } from 'pinia';
import { SmartViewEventBus } from 'store/pinia';
import { useReportsStore } from 'store/pinia/useReportsStore';
import { useSmartviewStore } from 'store/pinia/useSmartviewStore';
import { getCurrentState } from 'components/CesiumViewer/cesiumState';

export default {
    name: 'ReportsVue',
    components: {
        SmartViewDialogueBase,
        ReportAlert,
    },
    mixins: [viewsInfoMixin],
    props: {
        view: {
            type: Object,
            default: () => {
                return {
                    datasetPackage: {
                        dataset_name: 'Dataset Name',
                        dataset_group_uuid:
                            '11111111-1111-1111-1111-1111111111',
                    },
                };
            },
        },
    },
    data() {
        return {
            search: '',
            headers: [
                { title: 'User', key: 'user_name', align: 'start' },
                { title: 'Report Date', key: 'date' },
                { title: 'Asset Date', key: 'assetDate' },
                { title: 'View Type', key: 'viewType' },
                { title: 'Download', key: 'url', sortable: false },
            ],
            defaultSortBy: [{ key: 'date', order: 'desc' }],
            loading: true,
            pollInterval: null,
            pollCount: 0,
            errorCount: 0,
            site_uuid: null,
            requestController: null,
            requestInFlight: false,
            crossReferenceEnabled: false,
            crossReferenceViewUuid: null,
        };
    },
    computed: {
        showCrossReferenceButton() {
            return this.crossReferenceEnabled && this.crossReferenceViewUuid === this.view.viewUUID &&
                this.view_options[this.view.component]?.type === 'cesium_tiles_view';
        },
        ...mapState(useReportsStore, ['datasetGroups', 'errors']),
        ...mapState(useSmartviewStore, ['getIsReportMode']),
        reports() {
            // sometimes it was returning undefined before the ajax request had completed, halting js execution
            return typeof this.datasetGroups[this.datasetGroupUuid] ===
                'undefined'
                ? []
                : this.datasetGroups[this.datasetGroupUuid];
        },
        datasetGroupName() {
            return this.view.datasetPackage.name;
        },
        datasetGroupUuid() {
            return this.view.datasetPackage.dataset_group_uuid;
        },
    },
    watch: {
        'view.viewUUID': {
            immediate: true,
            handler() { this.loadCrossReferenceCapability(); },
        },
        datasetGroupUuid: {
            immediate: true,
            handler() {
                if (this.requestController) {
                    this.requestController.abort();
                    this.requestController = null;
                    this.requestInFlight = false;
                }
                this.getReports();
            },
        },
    },
    mounted() {
        if (!this.datasetGroups[this.datasetGroupUuid]) {
            this.addReports([this.datasetGroupUuid, []]);
        }
        this.pollInterval = setInterval(() => {
            this.getReports();
        }, 5000);
        // update every 5 seconds

        // get and store site_uuid
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if(urlParams.has('site')){
            this.site_uuid = urlParams.get('site');
        }
    },
    beforeDestroy() {
        this.teardownPolling();
        this.addErrors([this.datasetGroupUuid, null]);
    },
    beforeUnmount() {
        this.teardownPolling();
        this.addErrors([this.datasetGroupUuid, null]);
    },
    methods: {
        async loadCrossReferenceCapability() {
            this.crossReferenceEnabled = false;
            this.crossReferenceViewUuid = null;
            if (this.view_options[this.view.component]?.type !== 'cesium_tiles_view') return;
            const viewUuid = this.view.viewUUID;
            try {
                const response = await axios.get(`/api/cross-reference-reports/capabilities/${viewUuid}/`);
                if (this.view.viewUUID !== viewUuid) return;
                this.crossReferenceEnabled = response.data.enabled === true;
                this.crossReferenceViewUuid = viewUuid;
            } catch (_) {
                if (this.view.viewUUID !== viewUuid) return;
                this.crossReferenceEnabled = false;
            }
        },
        ...mapActions(useReportsStore, ['addReports', 'addErrors']),
        ...mapActions(useSmartviewStore, ['setIsReportMode']),
        teardownPolling() {
            clearInterval(this.pollInterval);
            this.pollInterval = null;
            if (this.requestController) {
                this.requestController.abort();
                this.requestController = null;
            }
            this.requestInFlight = false;
        },
        getReports() {
            if (!this.datasetGroupUuid || this.requestInFlight) {
                return;
            }

            if (this.requestController) {
                this.requestController.abort();
            }

            this.requestController = new AbortController();
            this.requestInFlight = true;

            axios
                .get(`/api/database/get_reports/${this.datasetGroupUuid}`, {
                    signal: this.requestController.signal,
                })
                .then(response => {
                    // check for changes
                    for (let report in response.data) {
                        if (
                            !(report in this.reports) ||
                            this.reports[report].state !==
                                response.data[report].state
                        ) {
                            if (response.data[report].state === 'SUCCESS') {
                                // if report finished processing notify the user
                                this.addErrors([
                                    this.datasetGroupUuid,
                                    {
                                        type: response.data[report].state,
                                        url: response.data[report].url,
                                    },
                                ]);
                            } else {
                                this.addErrors([
                                    this.datasetGroupUuid,
                                    {
                                        type: response.data[report].state,
                                        image: response.data[report].state_meta
                                            ? response.data[report].state_meta
                                                  .current
                                            : null,
                                        total: response.data[report].state_meta
                                            ? response.data[report].state_meta
                                                  .total
                                            : null,
                                    },
                                ]);
                            }
                        }
                    }

                    this.addReports([this.datasetGroupUuid, response.data]);

                    if (
                        this.datasetGroupUuid in this.errors &&
                        this.errors[this.datasetGroupUuid] !== null &&
                        this.errors[this.datasetGroupUuid].type === 'error'
                    ) {
                        this.addErrors([this.datasetGroupUuid, null]);
                    }

                    this.loading = false;
                    this.pollCount++;
                    this.errorCount = 0;
                })
                .catch(error => {
                    if (
                        error.name === 'CanceledError' ||
                        error.code === 'ERR_CANCELED'
                    ) {
                        return;
                    }

                    if (error.response && error.response.status === 403) {
                        this.addErrors([
                            this.datasetGroupUuid,
                            { type: 'forbidden' },
                        ]);
                    } else {
                        this.errorCount++;
                    }

                    if (this.errorCount > 5) {
                        this.addErrors([
                            this.datasetGroupUuid,
                            { type: 'error' },
                        ]);
                    }
                })
                .finally(() => {
                    this.requestInFlight = false;
                    this.requestController = null;
                });
        },
        async retryCapturedReport(item) {
            try {
                await axios.post(`/api/cesium-reports/${item.report_id}/retry/`);
                this.getReports();
            } catch (error) {
                this.addErrors([this.datasetGroupUuid, { type: 'error' }]);
            }
        },
        generateReport(mode = 'browser_capture') {
            trackReportAndExportEvents.reportGenerated(this.view);
            if (
                this.view_options[this.view.component].type !==
                    'inspection_view' &&
                this.view_options[this.view.component].type !==
                    'thermal_inspection_view'
            ) {
                getCurrentState(this.view.id).report.requestedMode = mode === 'cross_reference' ? mode : null;
                this.setIsReportMode(true);
                this.$emit('close-dialog');
                this.$nextTick(() => {
                    SmartViewEventBus.$emit('cesiumReport', this.view.id);
                });
            } else {
                axios
                    .post(`api/view/inspection/report/generate/`, {
                        view: this.view.viewUUID,
                        site: this.site_uuid,
                    })
                    .then(() => {
                        this.getReports();
                    })
                    .catch(error => {
                        this.addErrors([
                            this.datasetGroupUuid,
                            { type: 'error' },
                        ]);
                        throw error;
                    });
            }
        },
    },
};
</script>
